import { createGlobalStyle } from 'styled-components';
import { colors } from './colors';
import { fonts } from './fonts';

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;1,400;1,500&display=swap');

  * {
    margin: 0;
    padding: 0;  
    outline: 0;
    box-sizing: border-box;
  }

  html, body, #root, td, th {
    -webkit-font-smoothing: antialiased !important;
    font-family: ${fonts.primary}, ${fonts.secondary}, sans-serif;
    text-decoration: none;
    font-size: 16px;
    color: ${colors.greyDark};
    text-rendering: optimizeLegibility;
  }
  
  
  body {
    background: ${colors.alabaster};
  }

  ul, ol {
    list-style-type: none;
    margin: 0;
  }

  strong, h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
  }

   /* DATEPICKER */

   .SingleDatePicker_picker {
      z-index: 1051 !important;
    }

    .CalendarMonth {
      & .CalendarMonth_caption {
        padding-top: 13px !important;
        padding-left: 40px !important;
        padding-right: 40px !important;

        & #select-month {
          width: 110px;
        }
      }
      & select, & .DayPickerNavigation_button, & .CalendarDay {
        border: 1px solid ${colors.greyLight} !important;
      }
      & .CalendarDay__selected {
        background: ${colors.primary};
      }
    }

  button {
    cursor: pointer;
  }
`;
